import { ShipmentEvent } from '@/model/shipmentEvent/ShipmentEvent';
import {
  isMilestone,
  isShipmentMilestoneAssociatedEventType,
} from '@/model/shipmentEvent/ShipmentEventType';
import { ShipmentMilestoneAssociatedEvent } from '@/model/shipmentEvent/ShipmentMilestoneAssociatedEvent';
import { ShipmentMilestoneEvent } from '@/model/shipmentEvent/ShipmentMilestoneEvent';

export const buildShipmentEvent = (
  data: Partial<ShipmentEvent>,
): ShipmentEvent => {
  const eventType = data.eventType;
  if (!eventType) {
    console.warn('Missing `ShipmentEvent.eventType`', data);
  }

  if (eventType && isMilestone(eventType)) {
    return new ShipmentMilestoneEvent(data);
  } else if (isShipmentMilestoneAssociatedEventType(eventType)) {
    return new ShipmentMilestoneAssociatedEvent(data);
  } else {
    return new ShipmentEvent(data);
  }
};

export const buildShipmentEvents = (data: any[]): ShipmentEvent[] => {
  const events = data.map(buildShipmentEvent);
  events
    .filter((e) => e instanceof ShipmentMilestoneEvent)
    .forEach((milestone) => {
      const arriveEvent = events.find((e) => e.id === milestone.arriveEventId);
      if (arriveEvent) {
        milestone.actualArrival = arriveEvent.actualDate;
      }
    });
  return events;
};
